// src/pages/auth/ResetPasswordPage.jsx
import { useForm } from 'react-hook-form'
import { useSearchParams, useNavigate, Link } from 'react-router-dom'
import { authApi } from '@/api/services'
import { Button, Input } from '@/components/common/ui'
import toast from 'react-hot-toast'

export default function ResetPasswordPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm()

  const onSubmit = async (values) => {
    try {
      await authApi.resetPassword({ ...values, token: params.get('token'), email: params.get('email') })
      toast.success('Password reset! Please sign in.')
      navigate('/login')
    } catch (err) {
      toast.error(err.response?.data?.message || 'Reset failed — try requesting a new link')
    }
  }

  return (
    <div className="card p-8">
      <h1 className="font-display font-bold text-2xl mb-1">Set new password</h1>
      <p className="text-sm text-muted mb-7">Choose a strong password for your account</p>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <Input label="New password" type="password" placeholder="Min 8 characters"
          error={errors.password?.message} {...register('password', { required: true, minLength: 8 })} />
        <Input label="Confirm password" type="password" placeholder="Re-enter password"
          error={errors.password_confirmation?.message} {...register('password_confirmation', { required: true })} />
        <Button type="submit" loading={isSubmitting} className="w-full justify-center py-3">Reset Password</Button>
      </form>
      <p className="text-center text-sm text-muted mt-5">
        <Link to="/login" className="text-pink font-bold hover:underline">Back to Sign In</Link>
      </p>
    </div>
  )
}
